import { Component } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { LoginService } from '../../services/login.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})

export class HeaderComponent{

    searchVisible : boolean = false;
    quickViewVisible : boolean = false;
    isFolded : boolean;
    isExpand : boolean;
    adminName: string;

    constructor(
        private themeService: ThemeConstantService,
        private LoginService: LoginService,
        private authenticationService: AuthenticationService,
        private modalService: NzModalService
    ) {}

    ngOnInit(): void {
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);

        this.adminName= this.LoginService.getCookie("adminName")

    }

    toggleFold() {
        this.isFolded = !this.isFolded;
        this.themeService.toggleFold(this.isFolded);
    }

    toggleExpand() {
        this.isFolded = false;
        this.isExpand = !this.isExpand;
        this.themeService.toggleExpand(this.isExpand);
        this.themeService.toggleFold(this.isFolded);
    }

    searchToggle() {
        this.searchVisible = !this.searchVisible;
    }

    quickViewToggle(): void {
        this.quickViewVisible = !this.quickViewVisible;
    }

    notificationList = [
        {
            title: 'You received a new message',
            time: '8 min',
            icon: 'mail',
            color: 'ant-avatar-' + 'blue'
        },
        {
            title: 'New user registered',
            time: '7 hours',
            icon: 'user-add',
            color: 'ant-avatar-' + 'cyan'
        },
        {
            title: 'System Alert',
            time: '8 hours',
            icon: 'warning',
            color: 'ant-avatar-' + 'red'
        },
        {
            title: 'You have a new update',
            time: '2 days',
            icon: 'sync',
            color: 'ant-avatar-' + 'gold'
        }
    ];

    logout(): void {
        this.authenticationService.logout();
    }

    showConfirm(): void {
        this.modalService.confirm({
          nzTitle: 'Log out?',
          nzContent: 'You’ll be logged out from your session.',
          nzOkText: 'Log out',
          nzCancelText: 'Cancel',
          nzCentered: true,
          nzOnOk:()=>{
            this.logout();
          }
        });
      }
}
